import type { WTheme } from '@/types';
import { defineStore } from 'pinia';

const defaultTheme: WTheme = {
  colorscheme: {
    primary: '#1f8fff',
    secondary: '#00a885',
    gray: '#69747c',
  },
  button: {
    borderRadius: '0.5rem',
    textTransform: 'inherit',
    boxShadow: '0 0 0',
  },
  logo: null,
};

const influenceoTheme: WTheme = {
  colorscheme: {
    primary: '#ed3e44',
    secondary: '#f58e8f',
    gray: '#a6a6a8',
  },
  button: {
    borderRadius: '2px',
    textTransform: 'uppercase',
    boxShadow: '0 0 5px #0003',
  },
  logo: 'https://hellopartner.com/content/images/size/w1200/wp-content/uploads/2019/08/influenceoimage.png',
};

export const influenceoHosts = [
  'influenceo.platform.wowzi.co',
  'influenceo.platform.wazii.io',
  // 'localhost:5174', // add your localhost here
];

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: defaultTheme,
  }),

  actions: {
    applyTheme() {
      if (this.theme) {
        const settings = [
          // { key: '--theme-primary-color', value: this.theme.colorscheme.primary },
          { key: '--theme-secondary-color', value: this.theme.colorscheme.secondary },
          { key: '--theme-button-border-radius', value: this.theme.button?.borderRadius ?? '' },
          { key: '--theme-button-text-transform', value: this.theme.button?.textTransform ?? '' },
          { key: '--theme-button-box-shadow', value: this.theme.button?.boxShadow ?? '' },
        ];
        settings.forEach(setting => {
          document.documentElement.style.setProperty(setting.key, setting.value);
        });
      }
    },
    setTheme(theme: WTheme) {
      this.theme = theme;
    },
    resetTheme() {
      this.theme = influenceoHosts.includes(window.location.host) ? influenceoTheme : defaultTheme;
    },
  },

  getters: {},
});
